export const transformCashFlowApiData = (apiData) => {
  if (!apiData?.columns || !apiData?.rows) {
    return { headers: [], rows: [] };
  }

  const totalColumnIndex = apiData.columns.findIndex(
    (column) => column.id === "row_totals"
  );
  const sortedColumns = [...apiData.columns];

  if (totalColumnIndex > -1) {
    const [totalColumn] = sortedColumns.splice(totalColumnIndex, 1);
    sortedColumns.push(totalColumn);
  }

  const rows = [];

  const reorderValues = (values = []) => {
    const nextValues = [...values];
    if (totalColumnIndex > -1 && nextValues.length > totalColumnIndex) {
      const [totalValue] = nextValues.splice(totalColumnIndex, 1);
      nextValues.push(totalValue);
    }
    return nextValues;
  };

  const processNode = (node, level = 0, parentId = null) => {
    const hasChildren = Array.isArray(node.children) && node.children.length > 0;
    const rowId = node.id || `row-${level}-${rows.length}`;

    let type = "data";
    if (node.group === "FREE_CASH_FLOW") type = "grand-total";
    else if (node.summary) type = "sub-total";
    else if (level === 0) type = "level-0";
    else if (level === 1) type = "level-1";

    rows.push({
      id: rowId,
      parentId,
      type,
      level,
      hasChildren,
      label: node.label || node.name || "",
      values: [node.label || node.name || "", ...reorderValues(node.values)],
      summaryValues: node.summary?.sub_totals,
      metadata: node.metadata,
      account_id: node.id?.startsWith("acc_") ? node.id : null,
    });

    node.children?.forEach((child) => processNode(child, level + 1, rowId));

    if (node.summary && type !== "grand-total") {
      rows.push({
        id: `${rowId}-summary`,
        parentId: rowId,
        type: "sub-total",
        level,
        hasChildren: false,
        label: node.summary.label,
        values: [node.summary.label, ...reorderValues(node.summary.sub_totals)],
        summaryValues: reorderValues(node.summary.sub_totals),
      });
    }
  };

  apiData.rows.forEach((row) => processNode(row, 0));

  return {
    headers: ["ACCOUNT", ...sortedColumns.map((column) => column.label)],
    rows,
  };
};

export const formatNumber = (value) => {
  if (value === null || value === undefined || value === "" || value === "-") {
    return "-";
  }

  if (typeof value === "string" && value.includes("%")) {
    return value;
  }

  const numericValue =
    typeof value === "number"
      ? value
      : parseFloat(String(value).replace(/,/g, ""));

  if (Number.isNaN(numericValue)) {
    return String(value);
  }

  return numericValue.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const isNegative = (value) => {
  if (value === null || value === undefined || value === "") return false;
  if (typeof value === "number") return value < 0;

  const numericValue = parseFloat(String(value).replace(/,/g, ""));
  return !Number.isNaN(numericValue) && numericValue < 0;
};
